module.exports = __webpack_public_path__ + "static/media/tu-dublin.bf3a84a0.png";